<template>
    <div id="form-inbox">
        <div class="header">
            <div class="pagination-controls">
                <div class="pagination-buttons">
                    <button class="page-btn prev-btn" @click="prevPage" :disabled="answersData.currentPage === 1">
                        <md-icon class="icon">chevron_left</md-icon>
                    </button>
                    <div class="page-info">
                        <span class="current-page">{{ answersData.currentPage }}</span>
                        <span class="separator">/</span>
                        <span class="total-pages">{{ answersData.totalPages }}</span>
                    </div>
                    <button class="page-btn next-btn" @click="nextPage" :disabled="answersData.currentPage >= answersData.totalPages">
                        <md-icon class="icon">chevron_right</md-icon>
                    </button>
                </div>
                <div class="page-size-selector">
                    <select v-model="localPageSize" @change="changePageSize" class="page-size-select">
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    <span class="page-size-label">{{ $t("form.itemsPerPage") }}</span>
                </div>
            </div>
            <div class="header-items-group">
                <div class="header-item" @click="$router.push({ path: '/form', query: { type: 'list' } })">
                    <md-icon class="icon">arrow_back</md-icon>
                    <span class="header-text">{{ $t("message.back") }}</span>
                </div>
                <div class="header-item"
                     @click="filterStatusForm('all')"
                     :data-active="filterStatus === 'all'">
                    <md-icon class="icon">all_inbox</md-icon>
                    <span class="header-text" :data-count="totalSubmissions">
                        Tümü
                    </span>
                </div>
                <div class="header-item"
                     @click="filterStatusForm('notRead')"
                     :data-active="filterStatus === 'notRead'">
                    <md-icon class="icon">inbox</md-icon>
                    <span class="header-text" :data-count="answersData.notRead">
                        {{ $t("form.inbox") }}
                    </span>
                </div>
                <div class="header-item"
                     @click="filterStatusForm('read')"
                     :data-active="filterStatus === 'read'">
                    <md-icon class="icon">send</md-icon>
                    <span class="header-text" :data-count="answersData.read">
                        {{ $t("form.read") }}
                    </span>
                </div>
                <div class="header-item"
                     @click="filterStatusForm('archive')"
                     :data-active="filterStatus === 'archive'">
                    <md-icon class="icon">archive</md-icon>
                    <span class="header-text" :data-count="answersData.archive">
                        {{ $t("chatbotv2.archive") }}
                    </span>
                </div>
                <div class="header-item"
                     @click="filterStatusForm('ticket')"
                     :data-active="filterStatus === 'ticket'">
                    <md-icon class="icon">confirmation_number</md-icon>
                    <span class="header-text" :data-count="answersData.ticket">
                        Ticket'dan Kapanan
                    </span>
                </div>
                <a-popover placement="bottomRight" trigger="click">
                    <template #default>
                        <div class="header-item">
                            <md-icon class="icon">download</md-icon>
                            <span class="header-text">{{ $t("report.download") }}</span>
                        </div>
                    </template>
                    <template #content>
                        <div class="dropdown-item" @click="handleEmailDownload('all')">
                            <md-icon class="icon">email</md-icon>
                            Tüm Veriyi Email ile Gönder
                        </div>
                        <div class="dropdown-item" @click="handleEmailDownload('selected')" v-if="selectedAnswer && selectedAnswer.submission">
                            <md-icon class="icon">email</md-icon>
                            Seçili Veriyi Email ile Gönder
                        </div>
                        <div class="dropdown-item" @click="handleDirectDownload('selected')" :class="{ 'disabled': !selectedAnswer || !selectedAnswer.submission }">
                            <md-icon class="icon">download</md-icon>
                            Seçili Veriyi Hemen İndir
                            <span v-if="!selectedAnswer || !selectedAnswer.submission" style="color: #999; font-size: 11px;"> (Önce bir yanıt seçin)</span>
                        </div>
                    </template>
                </a-popover>
            </div>
        </div>

        <div class="form-inbox-container">
            <div class="inbox-menu">
                <InboxMenu
                    v-if="!loading"
                    :answersData="answersData"
                    :selected-submission-id="selectedAnswer && selectedAnswer.submission && selectedAnswer.submission._id"
                    @item-selected="formAnswers"
                />
                <div v-else class="spinner">
                    <svg class="spinner-icon" width="50px" height="50px" viewBox="0 0 50 50">
                        <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                    </svg>
                </div>
            </div>

            <div class="inbox-content">
                <InboxContents
                    v-if="selectedAnswer && selectedAnswer.submission"
                    :submission-id="selectedAnswer.submission._id"
                    :not-read-btn="notReadBtn"
                    :archiveBTN="archiveBTN"
                    @mark-as-read="updateData"
                    :key="selectedAnswer.submission._id + this.answersData.currentPage"
                />
                <div v-else class="no-data">
                    <md-icon class="md-icon">info</md-icon>
                    {{ $t("form.selectItemToViewDetails") }}
                </div>
            </div>
        </div>

        <a-modal
            v-model="showDownloadModal"
            :title="'Excel İndir'"
            :footer="null"
            @cancel="cancelDownloadModal"
            :width="400"
        >
            <div class="excel-download-modal">
                <div class="download-options">
                    <div class="option-title">Excel dosyasını nasıl almak istersiniz?</div>

                    <div class="option-item" @click="selectOption('self')">
                        <div class="option-radio">
                            <a-radio :checked="selectedOption === 'self'" />
                        </div>
                        <div class="option-content">
                            <div class="option-label">Bana Gönder</div>
                            <div class="option-description">{{ user.email }}</div>
                        </div>
                    </div>

                    <div class="option-item" @click="selectOption('other')">
                        <div class="option-radio">
                            <a-radio :checked="selectedOption === 'other'" />
                        </div>
                        <div class="option-content">
                            <div class="option-label">Başkasına Gönder</div>
                        </div>
                    </div>

                    <!-- Başkasına Gönder seçilince gösterilecek email alanı -->
                    <div v-if="selectedOption === 'other'" class="email-input-area">
                        <a-input
                            v-model="customEmail"
                            placeholder="Email adresi girin"
                            class="custom-email-input"
                        >
                            <template #prefix>
                                <a-icon type="mail" style="color: rgba(0,0,0,.25)" />
                            </template>
                        </a-input>
                    </div>
                </div>

                <div class="modal-footer">
                    <a-button @click="cancelDownloadModal">İptal</a-button>
                    <a-button
                        type="primary"
                        class="submit-button"
                        @click="submitEmailRequest"
                        :disabled="!isValidEmailSelected"
                    >
                        Gönder
                    </a-button>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import InboxMenu from "./FormInbox/InboxMenu.vue";
import InboxContents from "./FormInbox/InboxContents.vue";

export default {
    name: "FormInbox",
    components: {
        InboxMenu,
        InboxContents,
    },
    data() {
        return {
            formId: this.$route.params.formId,
            answersData: {
                notRead: 0,
                read: 0,
                archive: 0,
                ticket: 0,
                submissions: [],
                currentPage: 1,
                totalPages: 1,
            },
            selectedAnswer: null,
            loading: true,
            filterStatus: "notRead",
            notReadBtn: true,
            archiveBTN: false,
            localPageSize: 10,
            showDownloadModal: false,
            selectedOption: 'self',
            customEmail: '',
            downloadType: 'all',
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
        }),
        totalSubmissions() {
            return this.answersData.notRead + this.answersData.read + this.answersData.archive + this.answersData.ticket;
        },
        isValidEmailSelected() {
            if (this.selectedOption === 'self') {
                return true;
            } else if (this.selectedOption === 'other') {
                return this.customEmail && this.customEmail.includes('@');
            }
            return false;
        }
    },
    mounted() {
        const query = this.$route.query;
        const status = query.status || this.filterStatus;
        const page = parseInt(query.page, 10) || 1;
        const perPage = parseInt(query.perPage, 10) || 10;
        const submissionId = query.submissionId;

        this.localPageSize = perPage;
        this.answersData.currentPage = page;

        if(!Object.keys(query).length) {
            this.$router.replace({
                query: {
                    page: page,
                    perPage: perPage,
                    status: status
                }
            });
        }

        this.handleInitialLoad(status, page, submissionId);
    },
    methods: {
        ...mapActions({
            getFormSubmissions: "forms/getFormSubmissions",
            downloadFormDataToExcelWithEmail: "forms/downloadFormDataToExcelWithEmail",
            downloadFormDataToExcelDirect: "forms/downloadFormDataToExcelDirect",
        }),
        async filterStatusForm(status) {
            try {
                this.loading = true;
                this.filterStatus = status;
                this.notReadBtn = status === "notRead";

                if (status === "read") {
                    this.archiveBTN = true;
                } else {
                    this.archiveBTN = false;
                }
                this.selectedAnswer = null;

                this.answersData.currentPage = 1;
                this.localPageSize = 10;

                await this.getInboxForm(status, 1);

                this.$router.push({
                    query: {
                        page: 1,
                        perPage: 10,
                        status: status
                    }
                });

                if(this.answersData.submissions.length > 0) {
                    const firstId = this.answersData.submissions[0].submission._id;
                    this.formAnswers(firstId);
                }
            } catch (error) {
                console.error("Filter error:", error);
                this.$toast.error(this.$t('errors.filterError'));
            } finally {
                this.loading = false;
            }
        },
        async getInboxForm(status = this.filterStatus, page = 1) {
            try {
                this.loading = true;
                const data = await this.getFormSubmissions({
                    siteId: this.site._id,
                    formId: this.formId,
                    status: status,
                    page: page,
                    perPage: this.localPageSize
                });

                if(data) {
                    this.answersData = {
                        submissions: data.submissions,
                        notRead: data.notRead,
                        read: data.read,
                        archive: data.archive,
                        ticket: data.ticket,
                        total: data.total,
                        currentPage: page,
                        totalPages: Math.ceil(data.total / this.localPageSize)
                    };

                    const currentSubmissionId = this.$route.query.submissionId;
                    if(currentSubmissionId) {
                        const exists = data.submissions.some(
                            s => s.submission._id === currentSubmissionId
                        );
                        if(exists) this.formAnswers(currentSubmissionId);
                    }
                }
            } catch (error) {
                console.error("Error fetching submissions:", error);
                this.$toast.error(this.$t('errors.fetchError'));
                throw error;
            } finally {
                this.loading = false;
            }
        },
        formAnswers(submissionId) {
            const selected = this.answersData.submissions.find(
                item => item.submission._id === submissionId
            );
            if(selected) {
                this.selectedAnswer = selected;
                this.$router.push({
                    query: {
                        ...this.$route.query,
                        submissionId: submissionId
                    }
                });
            }
        },
        updateData(event) {
            const { submissionId, status, previousStatus } = event;

            const submissionIndex = this.answersData.submissions.findIndex(
                item => item.submission._id === submissionId
            );

            if (submissionIndex !== -1) {
                if (previousStatus === "notRead" && status === "read") {
                    this.answersData.notRead = Math.max(0, this.answersData.notRead - 1);
                    this.answersData.read = this.answersData.read + 1;
                } else if (previousStatus === "read" && status === "archive") {
                    this.answersData.read = Math.max(0, this.answersData.read - 1);
                    this.answersData.archive = this.answersData.archive + 1;
                } else if (previousStatus === "notRead" && status === "archive") {
                    this.answersData.notRead = Math.max(0, this.answersData.notRead - 1);
                    this.answersData.archive = this.answersData.archive + 1;
                }

                this.$set(this.answersData.submissions[submissionIndex], 'status', status);

                const shouldRemoveFromCurrentFilter =
                    (this.filterStatus === "notRead" && status !== "notRead") ||
                    (this.filterStatus === "read" && status !== "read") ||
                    (this.filterStatus === "archive" && status !== "archive");

                if (shouldRemoveFromCurrentFilter) {
                    this.answersData.submissions = this.answersData.submissions.filter(
                        item => item.submission._id !== submissionId
                    );

                    if (this.answersData.submissions.length > 0) {
                        this.$nextTick(() => {
                            this.formAnswers(this.answersData.submissions[0].submission._id);
                        });
                    } else if (this.answersData.currentPage > 1) {
                        this.changePage(this.answersData.currentPage - 1);
                    } else {
                        this.filterStatusForm('all');
                    }
                } else {
                    this.$forceUpdate();
                }
            }
        },
        handleMarkAsReadError(event) {
            const { submissionId, error } = event;

            this.getInboxForm(this.filterStatus, this.answersData.currentPage);

            this.$toast.error('İşlem sırasında bir hata oluştu. Lütfen tekrar deneyin.');
        },
        handleEmailDownload(type) {
            this.downloadType = type;
            this.selectedOption = 'self';
            this.customEmail = '';
            this.showDownloadModal = true;
        },
        selectOption(option) {
            this.selectedOption = option;
        },
        cancelDownloadModal() {
            this.showDownloadModal = false;
            this.selectedOption = 'self';
            this.customEmail = '';
        },
        submitEmailRequest() {
            const email = this.selectedOption === 'self' ? this.user.email : this.customEmail;
            this.sendExcelToEmail(email);
        },
        sendExcelToEmail(email) {
            const submissionId = this.downloadType === 'selected' && this.selectedAnswer && this.selectedAnswer.submission ? this.selectedAnswer.submission._id : null;

            const params = {
                siteId: this.site._id,
                formId: this.formId,
                submissionId: submissionId,
                email: email
            };

            this.showDownloadModal = false;
            this.$message.success('Talebiniz oluştu, en kısa sürede mail yolu ile ileteceğiz');

            this.downloadFormDataToExcelWithEmail(params)
                .then((data) => {
                    console.log("Excel talebi tamamlandı:", data);
                })
                .catch((err) => {
                    console.error("Excel oluşturma hatası:", err);
                    this.$message.error('Excel oluşturma sırasında bir hata oluştu');
                });
        },
        async handleDirectDownload(type) {
            try {
                this.$toast.info('Excel indiriliyor...');

                const submissionId = type === 'selected' && this.selectedAnswer && this.selectedAnswer.submission ? this.selectedAnswer.submission._id : null;

                if (!submissionId) {
                    this.$toast.error('Lütfen önce bir form yanıtı seçin');
                    return;
                }

                const downloadUrl = await this.downloadFormDataToExcelDirect({
                    siteId: this.site._id,
                    formId: this.formId,
                    submissionId: submissionId,
                });

                if (downloadUrl) {
                    const newTab = window.open(downloadUrl, "_blank");
                    if (newTab) {
                        newTab.focus();
                    } else {
                        this.$toast.error("Yeni sekme açılamadı. Lütfen tarayıcı ayarlarınızı kontrol edin.");
                    }
                    this.$toast.success('Excel başarıyla indirildi!');
                } else {
                    this.$toast.error('Excel indirilemedi: Bilinmeyen hata');
                }
            } catch (error) {
                console.error('Excel indirme hatası:', error);
                this.$toast.error('Excel indirilemedi: ' + (error.message || "Bilinmeyen hata"));
            }
        },

        async handleInitialLoad(status, page, submissionId) {
            try {
                await this.getInboxForm(status, page);

                if(submissionId) {
                    const exists = this.answersData.submissions.some(
                        answer => answer.submission._id === submissionId
                    );

                    if(!exists) {
                        await this.getInboxForm(status, page);
                    }

                    if(exists) {
                        this.formAnswers(submissionId);
                    } else {
                        this.$toast.error(this.$t('form.invalidSubmissionId'));
                        this.selectedAnswer = null;
                    }
                }
            } catch (error) {
                console.error('Initial load error:', error);
            }
        },
        async changePage(page) {
            this.answersData.currentPage = page;
            await this.getInboxForm(this.filterStatus, page);

            this.$router.push({
                query: {
                    page: page,
                    perPage: this.localPageSize,
                    status: this.filterStatus,
                },
            });
        },
        async changePageSize(event) {
            const newSize = parseInt(event.target.value, 10);
            this.localPageSize = newSize;
            this.answersData.currentPage = 1;
            await this.getInboxForm(this.filterStatus, 1);
            this.$router.push({
                query: {
                    page: 1,
                    perPage: newSize,
                    status: this.filterStatus,
                },
            });
        },
        prevPage() {
            if (this.answersData.currentPage > 1) {
                this.changePage(this.answersData.currentPage - 1);
            }
        },
        nextPage() {
            if (this.answersData.currentPage < this.answersData.totalPages) {
                this.changePage(this.answersData.currentPage + 1);
            }

        },
    },
    watch: {
        '$route.query': {
            deep: true,
            async handler(newQuery) {
                const status = newQuery.status || this.filterStatus;
                const page = parseInt(newQuery.page, 10) || 1;
                const perPage = parseInt(newQuery.perPage, 10) || 10;
                const submissionId = newQuery.submissionId;

                if(perPage !== this.localPageSize || status !== this.filterStatus) {
                    await this.getInboxForm(status, page);
                }

                if(submissionId) {
                    const exists = this.answersData.submissions.some(
                        item => item.submission._id === submissionId
                    );

                    if(!exists) {
                        await this.getInboxForm(status, page);
                    }

                    this.formAnswers(submissionId);
                }
            }
        }
    }
};
</script>

<style lang="scss" scoped>
#form-inbox {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 100%;
    background-color: #f5f7fa;

    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.75rem 1rem;
        min-height: 64px;
        background: #ffffff;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
        border-bottom: 1px solid #c7d0d7;
        flex-shrink: 0;
        overflow-x: auto;
        overflow-y: hidden;

        &::-webkit-scrollbar {
            height: 4px;
        }

        &::-webkit-scrollbar-track {
            background: #fafbfc;
        }

        &::-webkit-scrollbar-thumb {
            background: #c7d0d7;
            border-radius: 2px;
        }

        .header-items-group {
            display: flex;
            align-items: center;
            margin-left: auto;
            gap: 0.25rem;
        }

        .header-item {
            display: inline-flex;
            align-items: center;
            padding: 0.45rem 0.675rem;
            background: #fafbfc;
            border-radius: 6px;
            cursor: pointer;
            transition: all 0.2s ease;
            border: 1px solid #e8edf1;
            position: relative;
            white-space: nowrap;

            &:hover {
                background: #f6f8f9;
                border-color: #c7d0d7;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
                transform: translateY(-1px);

                .icon {
                    color: #121317;
                }

                .header-text {
                    color: #121317;
                }
            }

            &:active {
                transform: translateY(0);
            }

            &:first-child {
                background: #edf1f4;
                border-color: #c7d0d7;

                .icon, .header-text {
                    color: #5a5f72;
                }

                &:hover {
                    background: #e8edf1;
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);

                    .icon {
                        transform: translateX(-2px);
                        color: #121317;
                    }
                }
            }

            .icon {
                font-size: 0.9rem;
                margin-right: 0.45rem;
                color: #5a5f72;
                transition: all 0.2s ease;
            }

            .header-text {
                color: #121317;
                font-weight: 500;
                font-size: 0.73125rem;
                transition: all 0.2s ease;
                display: flex;
                align-items: center;
                white-space: nowrap;

                &[data-count]::after {
                    content: attr(data-count);
                    margin-left: 0.3375rem;
                    font-size: 0.61875rem;
                    background: #d1dbe0;
                    color: #121317;
                    padding: 0.1125rem 0.3375rem;
                    border-radius: 4px;
                    min-width: 1.125rem;
                    text-align: center;
                    font-weight: 600;
                    transition: all 0.2s ease;
                }
            }

            &[data-active="true"] {
                background: #5a5f72;
                border-color: #5a5f72;
                box-shadow: 0 2px 6px rgba(90, 95, 114, 0.15);

                .icon, .header-text {
                    color: #ffffff;
                }

                .header-text[data-count]::after {
                    background: rgba(255, 255, 255, 0.25);
                    color: #ffffff;
                }

                &:hover {
                    background: #484c5b;
                    box-shadow: 0 2px 8px rgba(90, 95, 114, 0.2);

                    .icon {
                        transform: scale(1.05);
                        color: #ffffff;
                    }
                }
            }
        }

        .pagination-controls {
            display: flex;
            align-items: center;
            gap: 1rem;
            padding-right: 1rem;
            border-right: 1px solid #e8edf1;
            margin-right: 0.75rem;

            .pagination-buttons {
                display: flex;
                align-items: center;
                gap: 0.5rem;
                background: #fafbfc;
                padding: 0.25rem;
                border-radius: 6px;
                border: 1px solid #e8edf1;

                .page-btn {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 28px;
                    height: 28px;
                    padding: 0;
                    background: transparent;
                    border: none;
                    border-radius: 4px;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    color: #5a5f72;

                    .icon {
                        font-size: 1.125rem;
                        color: inherit;
                    }

                    &:hover:not(:disabled) {
                        background: #ffffff;
                        color: #121317;
                        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
                    }

                    &:active:not(:disabled) {
                        transform: scale(0.95);
                    }

                    &:disabled {
                        opacity: 0.3;
                        cursor: not-allowed;
                    }
                }

                .page-info {
                    display: flex;
                    align-items: center;
                    gap: 0.375rem;
                    padding: 0 0.5rem;
                    min-width: 60px;
                    justify-content: center;

                    .current-page {
                        font-size: 0.8125rem;
                        font-weight: 600;
                        color: #121317;
                    }

                    .separator {
                        font-size: 0.75rem;
                        color: #9a9da9;
                        font-weight: 400;
                    }

                    .total-pages {
                        font-size: 0.75rem;
                        color: #5a5f72;
                        font-weight: 500;
                    }
                }
            }

            .page-size-selector {
                display: flex;
                align-items: center;
                gap: 0.5rem;

                .page-size-select {
                    padding: 0.375rem 0.625rem;
                    border: 1px solid #c7d0d7;
                    background-color: #ffffff;
                    color: #121317;
                    border-radius: 5px;
                    cursor: pointer;
                    font-size: 0.75rem;
                    font-weight: 500;
                    transition: all 0.2s ease;
                    min-width: 60px;
                    appearance: none;
                    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%235a5f72' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
                    background-repeat: no-repeat;
                    background-position: right 0.5rem center;
                    padding-right: 2rem;

                    &:hover {
                        border-color: #a6b3bd;
                        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                    }

                    &:focus {
                        outline: none;
                        border-color: #5a5f72;
                        box-shadow: 0 0 0 2px rgba(90, 95, 114, 0.1);
                    }

                    option {
                        background-color: #ffffff;
                        color: #121317;
                    }
                }

                .page-size-label {
                    font-size: 0.75rem;
                    color: #5a5f72;
                    font-weight: 500;
                    white-space: nowrap;
                }
            }
        }
    }

    .form-inbox-container {
        display: flex;
        flex: 1;
        gap: 0;
        padding: 0;
        min-height: 0;
        position: relative;

        .inbox-menu {
            min-width: 320px;
            max-width: 380px;
            width: 28%;
            flex-shrink: 0;
            background: white;
            display: flex;
            flex-direction: column;
            max-height: 100%;
            border-right: 1px solid #c7d0d7;
            position: relative;
            z-index: 1;

            & > div {
                flex: 1;
                overflow-y: auto;
                overflow-x: hidden;
                scrollbar-width: thin;
                scrollbar-color: #c7d0d7 #fafbfc;

                &::-webkit-scrollbar {
                    width: 6px;
                }

                &::-webkit-scrollbar-track {
                    background: #fafbfc;
                }

                &::-webkit-scrollbar-thumb {
                    background-color: #c7d0d7;
                    border-radius: 3px;

                    &:hover {
                        background-color: #a6b3bd;
                    }
                }
            }

            .spinner {
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100%;

                .spinner-icon {
                    width: 40px;
                    height: 40px;
                }

                .path {
                    stroke: #5a5f72;
                    stroke-linecap: round;
                }
            }
        }

        .inbox-content {
            flex: 1;
            min-width: 0;
            background: white;
            display: flex;
            flex-direction: column;
            max-height: 100%;
            overflow: hidden;
            position: relative;
            z-index: 0;
            padding: 10px;

            #inbox-content {
                flex: 1;
                overflow-y: auto;
                overflow-x: hidden;
                scrollbar-width: thin;
                scrollbar-color: #c7d0d7 #fafbfc;

                &::-webkit-scrollbar {
                    width: 6px;
                }

                &::-webkit-scrollbar-track {
                    background: #fafbfc;
                }

                &::-webkit-scrollbar-thumb {
                    background-color: #c7d0d7;
                    border-radius: 3px;

                    &:hover {
                        background-color: #a6b3bd;
                    }
                }
            }

            .no-data {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                height: 100%;
                padding: 2rem;
                text-align: center;
                color: #5a5f72;
                background: #fafbfc;

                .icon {
                    font-size: 3rem;
                    color: #9a9da9;
                    margin-bottom: 1rem;
                    opacity: 0.6;
                }
            }
        }

        @media screen and (max-width: 1400px) {
            .inbox-menu {
                width: 30%;
                min-width: 280px;
                max-width: 340px;
            }
        }

        @media screen and (max-width: 1200px) {
            .inbox-menu {
                width: 32%;
                min-width: 260px;
                max-width: 320px;
            }
        }

        @media screen and (max-width: 992px) {
            flex-direction: column;

            .inbox-menu {
                width: 100%;
                max-width: 100%;
                min-width: 100%;
                max-height: 300px;
                order: 1;
                border-right: none;
                border-bottom: 1px solid #c7d0d7;
            }

            .inbox-content {
                order: 2;
                min-height: 400px;
            }
        }

        @media screen and (max-width: 768px) {
            .inbox-menu {
                max-height: 250px;
            }

            .inbox-content {
                min-height: 350px;
            }
        }
    }
}

.dropdown-item {
    display: flex;
    align-items: center;
    padding: 0.75rem 1rem;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #121317;
    font-weight: 500;

    .icon {
        margin: 1px 5px 2px 0px;
        font-size: 1.2rem;
        color: #5a5f72;
        transition: all 0.2s ease;
    }

    &:hover {
        background-color: #f6f8f9;
        color: #121317;

        .icon {
            color: #121317;
        }
    }

    &.disabled {
        opacity: 0.4;
        cursor: not-allowed;
        color: #9a9da9;

        .icon {
            color: #9a9da9;
        }

        &:hover {
            background-color: transparent;
            color: #9a9da9;
        }
    }
}

.excel-download-modal {
    .download-options {
        margin-bottom: 20px;

        .option-title {
            font-size: 16px;
            font-weight: 500;
            margin-bottom: 16px;
            color: #262626;
        }

        .option-item {
            display: flex;
            align-items: center;
            padding: 12px 16px;
            border-radius: 6px;
            margin-bottom: 8px;
            cursor: pointer;
            transition: background-color 0.2s;

            &:hover {
                background-color: #f5f5f5;
            }

            .option-radio {
                margin-right: 12px;
            }

            .option-content {
                flex: 1;

                .option-label {
                    font-weight: 500;
                    margin-bottom: 2px;
                }

                .option-description {
                    font-size: 12px;
                    color: #8c8c8c;
                }
            }
        }

        .email-input-area {
            padding: 16px;
            margin-top: 4px;
            background-color: #f9f9f9;
            border-radius: 6px;

            .custom-email-input {
                width: 100%;
                border-radius: 4px;
            }
        }
    }

    .modal-footer {
        display: flex;
        justify-content: flex-end;
        margin-top: 24px;

        .submit-button {
            margin-left: 12px;
        }
    }
}
</style>
